import { Badge } from "@overmap-ai/blocks"
import { type ComponentProps, memo, use } from "react"

import { FilterRendererContext } from "../contexts/FilterRendererContext/context"

interface FilterCellBadgeProps extends ComponentProps<typeof Badge> {}

export const FilterCellBadge = memo<FilterCellBadgeProps>((props) => {
	const filterRendererContext = use(FilterRendererContext)
	const {
		ref,
		accentColor = "base",
		children,
		size = filterRendererContext.size,
		variant = filterRendererContext.variant,
		...rest
	} = props

	return (
		<Badge ref={ref} accentColor={accentColor} size={size} variant={variant} {...rest}>
			{children}
		</Badge>
	)
})
FilterCellBadge.displayName = "FilterCellBadge"
